import { useI18n } from '@i18n/useI18n';
import {
  AchevementProgress,
  Achievement,
  AchievementBadge,
  AchievementContainer,
  AchievementText,
  Content,
} from './ProfileAchievement.styled';
import RainbowLoader from '@components/Loaders/RainbowLoader';
import { StageColors } from '@models/BadgeColors';
import { CardTitle, GridCard } from '@components/GridCards/Common.styled';

// badges
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import BadgeSmall from '../RewardScreen/BadgeSmall';
import { useStore } from '@store/appStore';
import Badges from '@models/Badges';
import {
  Welcome,
  Comeback_kid,
  Friday_the_13,
  I_hate_mondays,
  May_the_4,
  Perfect_month,
  Perfect_week,
  Thank_god_its_friday,
} from '@models/BadgesAnimation';
import db from '@utils/db';
import CardInfo from '@components/GridCards/CardInfo';
import useOnScreen from '@components/Utils/useOnScreen';
import More_Icon from '@assets/svg/redeem/Badges.svg';
import Close_Icon from "@assets/svg/match/missing.svg";
import { Reward } from '@components/Reward/RewardItem/RewardItem.styled';
import { MoreBox } from '../ProfileRewardRedeem/RewardItem/RewardItem.styled';
import Modal from '@components/Buttons/Modal';
import { HeadLine, PopClose, PopContainer, PopTitle } from '@components/Guardian/Guardian.styled';
import { PopReward, PopRewardContainer } from '../ProfileRewardRedeem/ProfileRewardRedeem.styled';
import RewardScreen from '../RewardScreen';
import PreviewScreen from '../RewardScreen/PreviewScreen';

interface IProps {
  studentId: string;
  isAdmin?: boolean;
  updateTime?: any;
}

export const ProfileAchievement = forwardRef((props: IProps, ref) => {
  const i18n = useI18n();
  const { setBadge, setReward, setPreview, reward, preview, rewardScreen, setRewardScreen, setRewardScreenBadge, settings, rewardScreenBadge, badge} = useStore();
  const [badgeList, setBadgeList] = useState(null);
  const badgeSplash = useRef(null);
  const ref2 = useRef<HTMLDivElement>(null);
  const isVisible = useOnScreen(ref2);
  const loadingData = useRef(false)
  const [modal, setModal] = useState(false)
  const modalRef = useRef(null);

  useImperativeHandle(ref, () => ({
    setBadge() { },
  }));

  useEffect(() => {
    if (isVisible && !loadingData.current) {
      loadingData.current = true
      getBadges();
    }
  }, [isVisible, props.studentId, props.updateTime])

  useEffect(() => {
    if (badgeList && badgeList.length > 0 && !props.isAdmin) getBadgeSplash();
  }, [badgeList]);

  useEffect(() => {
    if (badgeSplash.current && badgeSplash.current.length > 0 && badgeList && badgeList.length > 0 && !rewardScreen)
      showScreen(badgeSplash.current);
  }, [rewardScreen]);

  const showScreen = (badges) => {
    if (badges.length > 0) {
      let badge = badges[0];
      let b = badgeList.find((b) => b.badge_id === badge.badge_id);
      if (b) {
        badgeSplash.current = badges.filter((b) => b.badge_id !== badge.badge_id);
        setRewardScreenBadge(b);
        setRewardScreen(true);
      }
    }
  };

  const getBadgeSplash = () => {
    db.GetBadges4Student_Splash(props.studentId, true).then((badgeSplashData) => {
      let temp = badgeSplashData;
      showScreen(temp);
    });
  };

  const getBadgesTeacher = () => {
    db.CalculateBadges4Student(props.studentId, settings.USEMERIT, settings.USEPAUSE).then(() => {
      db.GetAllBadges4Student(props.studentId).then((data) => {
        let badge_1 = data.find((b) => b.badge_id === 1);
        let badge_2 = data.find((b) => b.badge_id === 2);
        let badge_3 = data.find((b) => b.badge_id === 3);
        let badge_4 = data.filter((b) => b.badge_id === 4);
        let badge_5 = data.filter((b) => b.badge_id === 5);
        let badge_6 = data.filter((b) => b.badge_id === 6);
        let badge_7 = data.filter((b) => b.badge_id === 7);
        let badge_8 = data.find((b) => b.badge_id === 8);
        let badges = [];

        if (badge_1)
          badges.push({
            badge_id: 1,
            title: 'badge-title-' + 1,
            badgeImage: Badges.welcome,
            lottie: Welcome,
            stage: badge_1.progress === 100 ? 1 : 0,
            levels: 1,
            description: 'badge-decription-' + 1,
            rewardDecription: 'badge-reward-' + 1,
            progress: badge_1.progress,
          });
        if (badge_2)
          badges.push({
            badge_id: 2,
            title: 'badge-title-' + 2,
            badgeImage: Badges.friday_the_13,
            lottie: Friday_the_13,
            stage: badge_2.progress === 100 ? 1 : 0,
            levels: 1,
            description: 'badge-decription-' + 2,
            rewardDecription: 'badge-reward-' + 2,
            progress: badge_2.progress,
          });
        if (badge_3)
          badges.push({
            badge_id: 3,
            title: 'badge-title-' + 3,
            badgeImage: Badges.may_the_4,
            lottie: May_the_4,
            stage: badge_3.progress === 100 ? 1 : 0,
            levels: 1,
            description: 'badge-decription-' + 3,
            rewardDecription: 'badge-reward-' + 3,
            progress: badge_3.progress,
          });
        if (badge_4)
          badges.push({
            badge_id: 4,
            title: 'badge-title-' + 4,
            badgeImage: Badges.perfect_week,
            lottie: Perfect_week,
            stage: checkBadge(badge_4),
            levels: badge_4.length,
            description: 'badge-decription-' + 4,
            rewardDecription: 'badge-reward-' + 4,
            progress: getProgress(badge_4),
          });
        if (badge_5)
          badges.push({
            badge_id: 5,
            title: 'badge-title-' + 5,
            badgeImage: Badges.perfect_month,
            lottie: Perfect_month,
            stage: checkBadge(badge_5),
            levels: badge_5.length,
            description: 'badge-decription-' + 5,
            rewardDecription: 'badge-reward-' + 5,
            progress: getProgress(badge_5),
          });
        if (badge_6)
          badges.push({
            badge_id: 6,
            title: 'badge-title-' + 6,
            badgeImage: Badges.i_hate_mondays,
            lottie: I_hate_mondays,
            stage: checkBadge(badge_6),
            levels: badge_6.length,
            description: 'badge-decription-' + 6,
            rewardDecription: 'badge-reward-' + 6,
            progress: getProgress(badge_6),
          });
        if (badge_7)
          badges.push({
            badge_id: 7,
            title: 'badge-title-' + 7,
            badgeImage: Badges.thank_god_its_friday,
            lottie: Thank_god_its_friday,
            stage: checkBadge(badge_7),
            levels: badge_7.length,
            description: 'badge-decription-' + 7,
            rewardDecription: 'badge-reward-' + 7,
            progress: getProgress(badge_7),
          });
        if (badge_8)
          badges.push({
            badge_id: 8,
            title: 'badge-title-' + 8,
            badgeImage: Badges.comeback_kid,
            lottie: Comeback_kid,
            stage: 1,
            levels: 1,
            description: 'badge-decription-' + 8,
            rewardDecription: 'badge-reward-' + 8,
            progress: 100,
          });
        setBadgeList(badges);
      });
    });
  };

  const getBadges = () => {
    db.CalculateBadges4Student(props.studentId, settings.USEMERIT, settings.USEPAUSE).then(() => {
      db.GetAllBadges4Student(props.studentId).then((data) => {
        let badge_1 = data.filter((b) => b.badge_id === 1);
        let badge_2 = data.filter((b) => b.badge_id === 2);
        let badge_3 = data.filter((b) => b.badge_id === 3);
        let badge_4 = data.filter((b) => b.badge_id === 4);
        let badge_5 = data.filter((b) => b.badge_id === 5);
        let badge_6 = data.filter((b) => b.badge_id === 6);
        let badge_7 = data.filter((b) => b.badge_id === 7);
        let badge_8 = data.filter((b) => b.badge_id === 8);
        let badge_9 = data.filter((b) => b.badge_id === 9);
        let badge_10 = data.filter((b) => b.badge_id === 10);
        let badge_11 = data.filter((b) => b.badge_id === 11);
        let badge_12 = data.filter((b) => b.badge_id === 12);
        let badge_13 = data.filter((b) => b.badge_id === 13);
        let badge_14 = data.filter((b) => b.badge_id === 14);
        let badges = [];

        if (badge_1 && badge_1.length > 0)
          badges.push({
            badge_id: 1,
            title: 'badge-title-' + 1,
            badgeImage: Badges.welcome,
            lottie: Welcome,
            stage: checkBadge(badge_1),
            levels: 1,
            description: 'badge-decription-' + 1,
            rewardDecription: 'badge-reward-' + 1,
            progress: badge_1.progress,
          });
        if (badge_2 && badge_2.length > 0)
          badges.push({
            badge_id: 2,
            title: 'badge-title-' + 2,
            badgeImage: Badges.friday_the_13,
            lottie: Friday_the_13,
            stage: checkBadge(badge_2),
            levels: 1,
            description: 'badge-decription-' + 2,
            rewardDecription: 'badge-reward-' + 2,
            progress: badge_2.progress,
          });
        if (badge_3 && badge_3.length > 0)
          badges.push({
            badge_id: 3,
            title: 'badge-title-' + 3,
            badgeImage: Badges.may_the_4,
            lottie: May_the_4,
            stage: checkBadge(badge_3),
            levels: 1,
            description: 'badge-decription-' + 3,
            rewardDecription: 'badge-reward-' + 3,
            progress: badge_3.progress,
          });
        if (badge_4 && badge_4.length > 0)
          badges.push({
            badge_id: 4,
            title: 'badge-title-' + 4,
            badgeImage: Badges.perfect_week,
            lottie: Perfect_week,
            stage: checkBadge(badge_4),
            levels: badge_4.length,
            description: 'badge-decription-' + 4,
            rewardDecription: 'badge-reward-' + 4,
            progress: getProgress(badge_4),
          });
        if (badge_5 && badge_5.length > 0)
          badges.push({
            badge_id: 5,
            title: 'badge-title-' + 5,
            badgeImage: Badges.perfect_month,
            lottie: Perfect_month,
            stage: checkBadge(badge_5),
            levels: badge_5.length,
            description: 'badge-decription-' + 5,
            rewardDecription: 'badge-reward-' + 5,
            progress: getProgress(badge_5),
          });
        if (badge_6 && badge_6.length > 0)
          badges.push({
            badge_id: 6,
            title: 'badge-title-' + 6,
            badgeImage: Badges.i_hate_mondays,
            lottie: I_hate_mondays,
            stage: checkBadge(badge_6),
            levels: badge_6.length,
            description: 'badge-decription-' + 6,
            rewardDecription: 'badge-reward-' + 6,
            progress: getProgress(badge_6),
          });
        if (badge_7 && badge_7.length > 0)
          badges.push({
            badge_id: 7,
            title: 'badge-title-' + 7,
            badgeImage: Badges.thank_god_its_friday,
            lottie: Thank_god_its_friday,
            stage: checkBadge(badge_7),
            levels: badge_7.length,
            description: 'badge-decription-' + 7,
            rewardDecription: 'badge-reward-' + 7,
            progress: getProgress(badge_7),
          });
        if (badge_8 && badge_8.length > 0)
          badges.push({
            badge_id: 8,
            title: 'badge-title-' + 8,
            badgeImage: Badges.comeback_kid,
            lottie: Comeback_kid,
            stage: checkBadge(badge_8),
            levels: 1,
            description: 'badge-decription-' + 8,
            rewardDecription: 'badge-reward-' + 8,
            progress: badge_8.progress,
          });
        if (badge_9 && badge_9.length > 0)
          badges.push({
            badge_id: 9,
            title: 'badge-title-' + 9,
            badgeImage: Badges.halloween,
            lottie: null,
            stage: checkBadge(badge_9),
            levels: 1,
            description: 'badge-decription-' + 9,
            rewardDecription: 'badge-reward-' + 9,
            progress: badge_9.progress,
          });  
      if (badge_10 && badge_10.length > 0)
          badges.push({
            badge_id: 10,
            title: 'badge-title-' + 10,
            badgeImage: Badges.Pirate_day,
            lottie: null,
            stage: checkBadge(badge_10),
            levels: 1,
            description: 'badge-decription-' + 10,
            rewardDecription: 'badge-reward-' + 10,
            progress: badge_10.progress,
          });
          if (badge_11 && badge_11.length > 0)
          badges.push({
            badge_id: 11,
            title: 'badge-title-' + 11,
            badgeImage: Badges.april_fool,
            lottie: null,
            stage: checkBadge(badge_11),
            levels: 1,
            description: 'badge-decription-' + 11,
            rewardDecription: 'badge-reward-' + 11,
            progress: badge_11.progress,
          });
          if (badge_12 && badge_12.length > 0)
          badges.push({
            badge_id: 12,
            title: 'badge-title-' + 12,
            badgeImage: Badges.valentines_day,
            lottie: null,
            stage: checkBadge(badge_12),
            levels: 1,
            description: 'badge-decription-' + 12,
            rewardDecription: 'badge-reward-' + 12,
            progress: badge_12.progress,
          });
          if (badge_13 && badge_13.length > 0)
          badges.push({
            badge_id: 13,
            title: 'badge-title-' + 13,
            badgeImage: Badges.saint_patrick_day,
            lottie: null,
            stage: checkBadge(badge_13),
            levels: 1,
            description: 'badge-decription-' + 13,
            rewardDecription: 'badge-reward-' + 13,
            progress: badge_13.progress,
          });
          if (badge_14 && badge_14.length > 0)
          badges.push({
            badge_id: 14,
            title: 'badge-title-' + 14,
            badgeImage: Badges.wednesday_warrior,
            lottie: null,
            stage: checkBadge(badge_14),
            levels: badge_14.length,
            description: 'badge-decription-' + 14,
            rewardDecription: 'badge-reward-' + 14,
            progress: getProgress(badge_14.progress),
          });


        setBadgeList(badges);
        loadingData.current = false
      });
    });
  };

  const getProgress = (badges) => {
    let bronze = badges?.find((b) => b.level === 'bronze');
    let silver = badges?.find((b) => b.level === 'silver');
    let gold = badges?.find((b) => b.level === 'gold');

    if (bronze && bronze.progress < 100) {
      return bronze.progress;
    } else if (silver && silver.progress < 100) {
      return silver.progress;
    } else if (gold && gold.progress < 100) {
      return gold.progress;
    }
    return 0;
  };

  const checkBadge = (badges) => {
    let level = 0;
    let wood = badges.find((b) => b.level === 'wood' || (b.level === null && b.last_achieved_timestamp !== null));
    let bronze = badges.find((b) => b.level === 'bronze');
    let silver = badges.find((b) => b.level === 'silver');
    let gold = badges.find((b) => b.level === 'gold');

    if (wood) {
      level = 1;
    }

    if (bronze && bronze.progress === 100) {
      level = 2;
    }

    if (silver && silver.progress === 100) {
      level = 3;
    }

    if (gold && gold.progress === 100) {
      level = 4;
    }

    return level;
  };

  const showBadge = (badge) => {
    setBadge(badge);
    if (badge.stage === 0) setPreview(true);
    else setReward(true);
  };


  let itemList = [];

  if (badgeList && badgeList.length > 0) {
    badgeList.map((ac, index) =>
        itemList.push(
          <Achievement key={'badges_' + ac.title + index} onClick={() => showBadge(ac)}>
            <AchievementBadge colors={StageColors[ac.stage]}>
              <BadgeSmall preview={ac.stage === 0} badge={ac} />
              {/* {(b.progress !== undefined  && b.stage < b.levels && b.stage > 0) && <AchevementProgress progress={b.progress} colors={StageColors[b.stage + 1]}><div /></AchevementProgress>} */}
            </AchievementBadge>
            <AchievementText>{i18n.t(ac.title)}</AchievementText>
          </Achievement>
        ),
      );
  }

  return (<>

      {rewardScreen && <RewardScreen type={1} closeScreen={setRewardScreen} screenTitle={'new-badge'} badge={rewardScreenBadge} />}
      {reward && <RewardScreen type={2} closeScreen={setReward} screenTitle={'view-badge'} badge={badge} />}
      {preview && <PreviewScreen closeScreen={setPreview} screenTitle={'Badge preview'} badge={badge} />}

      
      {modal?<Modal ref={modalRef} onClose={setModal} backColor={"rgba(0,0,0,0.25)"}>
        <PopContainer normalPad={true} freeWidth={true} mid={true}>
          <PopTitle>{i18n.t("Badge katalog")}</PopTitle>
          <PopClose onClick={() => modalRef.current.handleClose()}><Close_Icon /></PopClose>
          <HeadLine />
          <PopRewardContainer freeWidth={true}>
            <PopReward>
              {itemList}
            </PopReward>
          </PopRewardContainer>
        </PopContainer>
      </Modal>:null}


      <GridCard ref={ref2} col={2} heightAuto={true}>
        <Content>
          <CardTitle>Attender Badges</CardTitle>
          <CardInfo text='info-text-badges' padding={true} />

          <AchievementContainer>
            {badgeList === null ?
              <RainbowLoader />
              :
              itemList.length <= 8?
                itemList
                :
                <>
                  {itemList.slice(0, 7)}
                  <Reward onClick={() => setModal(true)}>
                    <MoreBox>
                      <More_Icon />
                      {i18n.t("view-all-badges")}
                    </MoreBox>
                  </Reward>
                </>
            }
          </AchievementContainer>
        </Content>
      </GridCard>
    </>
  );
});

export default ProfileAchievement;
